module.exports = __webpack_public_path__ + "img/badge_color_holistic-finance.a5d855ce.svg";